import * as React from "react"
import Footer from "../Home/components/Footer"
import About from "../Home/components/About"
import { Button } from "@material-ui/core"
import { GAEvent } from "../../modules/GoogleAnalytics"
import useLoginPopup from "../../hooks/useLoginPopup"
import { useTrack } from "@hackler/react-sdk"
import { useEffect } from "react"
import FeatureFlagMainVisual from "./components/FeatureFlagMainVisual"
import FeatureFlagDescription from "./components/FeatureFlagDescription"
import IncidentSwitch from "./components/IncidentSwitch"
import Targeting from "./components/Targeting"
import { FormattedMessage } from "react-intl"
import GraduallyLaunch from "./components/GraduallyLaunch"
import SDKIntegration from "../../components/SDKIntegration"

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL
export default function FeatureFlag() {
  const track = useTrack()
  const loginPopup = useLoginPopup()

  useEffect(() => {
    track({ key: "homepage_feature_flag_view" })
  }, [])

  return (
    <>
      <FeatureFlagMainVisual />
      <FeatureFlagDescription />
      <GraduallyLaunch />
      <IncidentSwitch />
      <Targeting />
      <SDKIntegration />
      <About
        pageName="feature_flag"
        serviceButtonComponent={({ isMobile, className }) => (
          <Button
            color={"inherit"}
            variant={"contained"}
            fullWidth={isMobile}
            className={className}
            onClick={() => {
              GAEvent({
                category: "feature-flag-5",
                action: "click",
                label: "start feature flag",
              })
              track({ key: "homepage_all_feature_flag_start_click" })
              track({ key: "homepage_feature_flag_about_feature_flag_start_click" })
              loginPopup(`${dashboardUrl}/feature-flags`)
            }}>
            <strong>
              <FormattedMessage id={"btn_feature_flag_start"} />
            </strong>
          </Button>
        )}
      />
      <Footer pageName={"feature_flag"} />
    </>
  )
}
